/**
 * Created by RKL on 13/08/2015.
 */
define('kitProtDetailTabController',[
  'module',
  'underscore',
  'backbone',
  'app',
  'kitProtDetailView',
  'settings'
], function(
  module,
  _,
  Backbone,
  App,
  View
) {
  'use strict';

  var KitProtDetailTabController = {
    showTab: function(data) {
      if (!data.tab) {
        data.tab = 'detail';
      }
      this.showKitProtInfo(data);
    },

    showKitProtInfo: function(data) {
      var that = this;
      this.model = data.model;
      this.tab = data.tab;
      this.data = data;
      that.createView();
    },

    createView: function() {
      var view;
      view = new View({
        model: this.model
      });
      view.tempModel = new Backbone.Model(this.model.toJSON());
      this.view = view;

      App.regions.getRegion('main').currentView.getRegion('content').currentView.getRegion('kitProtDetailTab').show(view);
    }
  };

  module.exports = KitProtDetailTabController;
});
